import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import style from "./burger-menu-secondary-header.css";

function BurgerMenuSecondaryHeader({ renderText, onClickEvent }) {
    return (
        <div onClick={onClickEvent} className={style.secondaryMenuHeader}>
            <SVGIcon className={style.menuItemBigChevron} name="chevron" flip />
            {renderText}
        </div>
    );
}

export default BurgerMenuSecondaryHeader;

BurgerMenuSecondaryHeader.propTypes = {
    renderText: PropTypes.string.isRequired,
    onClickEvent: PropTypes.func.isRequired,
};

BurgerMenuSecondaryHeader.defaultProps = {
    renderText: "",
};
